import { useEffect, useState } from 'react';
import { Create, SelectInput, SimpleForm, TextInput, TopToolbar, required, useDataProvider } from 'react-admin';
import BackButton from '../../Components/BackButton';

const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);

// 添加电话号码校验
const validatePhone = (value: string) => {
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (value) {
        if (!phoneRegex.test(value)) {
            return '请输入有效的手机号码';
        }
    }
    return undefined;
};


// 添加用户名校验
const validateUsername = (value: string) => {
    if (!value) {
        return '用户名是必填项';
    }

    const usernameRegex = /^[a-zA-Z0-9_]{4,20}$/;
    if (!usernameRegex.test(value)) {
        return '用户名只能包含字母、数字和下划线，长度在4-20个字符之间';
    }
    return undefined;
};

// 添加姓名校验
const validateName = (value: string) => {
    if (!value) {
        return '姓名是必填项';
    }

    const nameRegex = /^[\u4e00-\u9fa5a-zA-Z0-9]{2,20}$/;
    if (!nameRegex.test(value)) {
        return '姓名只能包含中文、字母和数字，长度在2-20个字符之间';
    }
    return undefined;
};

// 添加密码校验
const validatePassword = (value: string) => {
    if (!value) {
        return '密码是必填项';
    }

    // 检查是否包含中文或全角字符
    const hasChineseOrFullWidth = /[\u4e00-\u9fa5\uFF00-\uFFFF]/.test(value);
    if (hasChineseOrFullWidth) {
        return '密码只能包含字母、数字以及英文标点符号';
    }

    // 检查长度
    if (value.length < 8 || value.length > 32) {
        return '密码长度应为8-32个字符之间';
    }

    return undefined;
};

export const userManageCreate = () => {
    const dataProvider = useDataProvider(); // 获取dataProvider
    const [rolesTypes, setRolesTypes] = useState([]);

    useEffect(() => {
        const fetchRolesTypes = async () => {
            try {
                let types = await dataProvider.getRolesList();
                types = types.map((item) => ({
                    id: item.roleCode,
                    name: item.name
                }));
                setRolesTypes(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        fetchRolesTypes();
    }, []);  // 空依赖数组确保只调用一次

    return (<Create actions={<ActionsToolbar />} redirect="list">
        <SimpleForm sx={{ width: { lg: '40%', xs: '100%' } }}>
            <TextInput label="用户名" source="username" validate={[required(), validateUsername]} />
            <TextInput label="姓名" source="name" validate={[required(), validateName]} />
            <TextInput label="密码" source="password" validate={[required(), validatePassword]} />
            <TextInput label="联系电话" source="phone" validate={[validatePhone]} />
            <SelectInput label="角色编码" source="roleCode" choices={rolesTypes} validate={[required()]} />
        </SimpleForm>
    </Create>
    );
}
